import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Tabs } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react'
import ConfirmationBox from '../../../../../../components/common/ConfirmationBox';
import MultiSelect from '../../../../../../components/common/MultiSelect';
import { names } from '../../../../../../data/people';

function NotifyTenant({workOrderNumber, setIsConfirmationBoxOpen}) {
    const onChange = (key) => {
        console.log(key);
      };
      const items = [
        {
          key: '1',
          label: `Tab 1`,
          children: <Form layout='vertical'>
          <Row>
              <Col span={24}>
                  <Form.Item label="Recipients" required>
                      <MultiSelect options={names} placeholder="Select" />
                  </Form.Item>
              </Col>
              <Col span={24}>
                  <Form.Item label="Send BCC to">
                      <MultiSelect options={names} placeholder="Select" />
                  </Form.Item>
              </Col>
              <Col span={24}>
                  <Form.Item label="Email subject" required>
                      <Input placeholder="Subject here" />
                  </Form.Item>
              </Col>
              <Col span={24}>
                  <Form.Item label="Email body">
                      <TextArea rows={10} />
                  </Form.Item>
              </Col>
              <Col span={24}>
                  <Form.Item label="Recipients" required>
                      <Checkbox>Attach the Work Order PDF</Checkbox>
                  </Form.Item>
              </Col>
          </Row>
          <div className="action-buttons">
              <Button type='primary'>Send</Button>
              <button className="cancel-btn" onClick={()=>setIsConfirmationBoxOpen(false)}>Cancel</button>
          </div>
      </Form>,
        },
        {
          key: '2',
          label: `Tab 2`,
          children: <Form layout='vertical'>
          <Row>
              <Col span={24}>
                  <Form.Item label="Notification Date" required>
                      <DatePicker style={{ width: "100%" }}/>
                  </Form.Item>
              </Col>
              <Col span={24}>
                  <Form.Item label="Notification Method" required>
                      <Select options={[{value: "Phone"}, {value: "Text"}, {value: "Walk-in"}]} defaultValue="Text" />
                  </Form.Item>
              </Col>
          </Row>
          <div className="action-buttons">
              <Button type='primary'>Save</Button>
              <button className="cancel-btn" onClick={()=>setIsConfirmationBoxOpen(false)}>Cancel</button>
          </div>
      </Form>,
        },
      ];
  return (
   
      <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
        <h2>Notify Tenant for Work Order #{workOrderNumber}</h2>
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
      </ConfirmationBox>
    
  )
}

export default NotifyTenant;
